import { Input } from '@iwoca/orion';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { numbersOnly } from '../../../../forms/helpers/normalisers';
import type { CompanyDetailsFormValues } from '../CompanyDetails.types';
import { FieldRow } from '../FieldRow';

export const TurnoverQuestion = () => {
    const intl = useIntl();
    const {
        control,
        formState: { errors }
    } = useFormContext<CompanyDetailsFormValues>();

    return (
        <FieldRow
            htmlFor="annualTurnover"
            label={
                <FormattedMessage
                    id="_.your_company.last_twelve_months_turnover"
                    defaultMessage="Last 12 months turnover"
                />
            }
        >
            <Controller
                control={control}
                name="annualTurnover"
                render={({ field: { onChange, value, onBlur, name, ref } }) => (
                    /* eslint-disable-next-line iwoca/input-a11y */
                    <Input
                        ref={ref}
                        id="annualTurnover"
                        name={name}
                        className="fs-exclude"
                        data-testid="annual-turnover-field"
                        value={value ? intl.formatNumber(Number(value)) : ''}
                        onBlur={onBlur}
                        onChange={(e) => onChange(numbersOnly(e.target.value))}
                        error={errors.annualTurnover?.message}
                    />
                )}
            />
        </FieldRow>
    );
};
